<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>edit</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Edit Invoice</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%">
      <v-form ref="editInvoiceForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12 class="mb-4">
            <v-autocomplete
              label="Company *"
              v-model="editItem.company_id"
              :items="companyTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
              required
              :rules="requiredRules"
            >
            </v-autocomplete>
          </v-flex>

          <v-flex xs12 class="mb-0">
            <v-layout row>
              <v-flex xs6 class="mr-1">
                <v-autocomplete
                  label="Client *"
                  v-model="editItem.client_id"
                  :items="clientTV"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  required
                  :rules="requiredRules"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  outline
                  label="Client Project name *"
                  required
                  v-model="editItem.client_project_name"
                  :rules="requiredRules"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 class="mb-0">
            <v-layout row>
              <v-flex xs6 class="mr-1">
                <v-autocomplete
                  label="Coordinator"
                  v-model="editItem.coordinator_id"
                  :items="coordinatorTV"
                  hide-details
                  hide-selected
                  item-text="text"
                  item-value="value"
                  outline
                  @change="onCoordinatorChange"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  outline
                  label="Commission %"
                  v-model="editItem.coordinator_commission_parcent"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-layout row>
            <v-flex xs6 class="pr-1">
              <v-menu
                v-model="paymentDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="editItem.invoice_date"
                    label="Date *"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="editItem.invoice_date"
                  @input="paymentDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs6>
              <v-text-field
                outline
                label="Invoice Number *"
                required
                v-model="editItem.invoice_number"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <!-- <v-flex xs12>
            <v-text-field
              outline
              label="Title *"
              required
              v-model="editItem.title"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex> -->
          <v-layout row>
            <v-flex xs6>
              <v-text-field
                outline
                label="Amount *"
                type="number"
                required
                v-model="editItem.amount"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 class="pl-1">
              <v-text-field
                outline
                label="VAT % *"
                type="number"
                required
                v-model="editItem.vat_parcent"
                :rules="requiredRules"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-textarea v-model="editItem.notes" outline label="Notes"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Cancel</v-btn>
      <v-btn
        color="blue"
        @click="editItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
        >Update</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { getTV, removeEmptyProps } from "../../mdsir/MdsirUtils";

export default {
  props: ["editItem", "clientTV", "companyTV", "coordinatorTV", "coordinators"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      paymentDateMenu: false,
      checkDateMenu: false,
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    editItemDo() {
      if (this.$refs.editInvoiceForm.validate()) {
        this.actionButtonClicked = true;
        this.put(
          "/invoice",
          removeEmptyProps(this.editItem, ["check_date", "account_head_id"])
        ).then((res) => {
          if (res.data.success) {
            this.onCancelled();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    onCoordinatorChange(coordinator_id) {
      const SC = this.coordinators.find((r) => r.id == coordinator_id);
      this.newItem.coordinator_commission_parcent = SC.commission_percent;
    },
  },
  mounted() {},
  created() {},
};
</script>
